/*
 * @Author: qiyuanchen
 * @Date: 2019-07-02 15:09:27
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 16:23:27
 */

import querystring from 'query-string';
import cookies from 'js-cookie';

import isFeedsFast from './isFeedsFast';
import { localStorage, track } from './index';
import { isTBS, isAndroid } from './UA';

const _ = require('lodash');
const pageId = 'zixun_sharepage';
const guid = cookies.get('qb_guid') || '';
const qua = cookies.get('qb_qua') || '';
/**
 * 获取配置数据
 * @param  {String} options.pageId
 * @param  {String} options.guid
 */
export function getPageConfigData() {
  const host = (window && window.location.host) || '';
  const hostName =
    host.indexOf('sparta.html5.qq.com') > -1 || host.indexOf('localhost') > -1
      ? 'pcd.sparta.html5.qq.com'
      : 'pcd.html5.qq.com';

  const params = querystring.stringify({
    pageId,
    guid,
  });
  return window
    .fetch(`//${hostName}/api/getPageConfigData?${params}`, {
      method: 'get',
    })
    .then((res) => {
      if (res.status >= 200 && res.status < 300) {
        return res;
      }
      const error = new Error(res.statusText);
      error.res = res;
      throw error;
    })
    .then((res) => res.json())
    .then((res) => res)
    .catch((e) => {
      throw e;
    });
}

/**
 * 上报数据
 * @param  {String} options.pageId
 * @param  {String} options.guid
 * @param  {String} options.qua
 * @param  {String} options.profileId
 * @param  {String} options.action
 */
export function dmpDataReport({ profileId, action }) {
  const host = (window && window.location.host) || '';
  const hostName =
    host.indexOf('sparta.html5.qq.com') > -1 || host.indexOf('localhost') > -1
      ? 'pcd.sparta.html5.qq.com'
      : 'pcd.html5.qq.com';

  const params = JSON.stringify({
    pageId,
    guid,
    qua,
    profileId,
    action,
  });
  return window
    .fetch(`//${hostName}/api/dmpDataReport`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: params,
    })
    .then((res) => {
      if (res.status >= 200 && res.status < 300) {
        return res;
      }
      const error = new Error(res.statusText);
      error.res = res;
      throw error;
    })
    .then((res) => res.json())
    .then((res) => res)
    .catch((e) => {
      throw e;
    });
}

/**
 * 是否要拉快报
 */
export function isLoadKuaiBao() {
  try {
    if (typeof window !== 'undefined') {
      const profile = localStorage.getItem('pageConfigData') || {};
      const isFF = isFeedsFast();
      const isKuaibao =
        (!isFF &&
          isAndroid(window.navigator.userAgent) &&
          isTBS(window.navigator.userAgent) &&
          _.result(profile, 'profileData.loadKuaiBao', false)) ||
        false;
      // console.log('isKuaibao s=', isKuaibao);
      return isKuaibao;
    }
  } catch (e) {
    // console.log('isKuaibao e=', e);
    return false;
  }
}

/**
 * 获取实验ID
 */
export function getProfileId() {
  try {
    if (typeof window !== 'undefined' && isLoadKuaiBao()) {
      return _.result(localStorage.getItem('pageConfigData') || {}, 'profileId', '');
    }
  } catch (e) {
    return '';
  }
}

/**
 *  "loadKuaiBao": true,
    "barStyleValue": "test_1",    // 底部bar实验值 test_1,test_2,test_3
    "articleImageBtn": true,         // 正文图片实验是否显示按钮
    "userInfoStyleValue": "1_test",   // 用户信息实验样式
    "backPageUrl": "https://www.qq.com" //返回键url
 */
/**
 * 底部bar实验值
 */
export function getBarStyleValue() {
  try {
    if (typeof window !== 'undefined') {
      return _.result(localStorage.getItem('pageConfigData') || {}, 'profileData.barStyleValue', '');
    }
  } catch (e) {
    return '';
  }
}

/**
 * 正文图片实验是否显示按钮
 */
export function isArticleImageBtn() {
  try {
    if (typeof window !== 'undefined') {
      return _.result(localStorage.getItem('pageConfigData') || {}, 'profileData.articleImageBtn', false);
    }
  } catch (e) {
    console.log('articleImageBtn e=', e);
    return false;
  }
}

/**
 * 用户信息实验样式
 */
export function getUserInfoStyleValue() {
  try {
    if (typeof window !== 'undefined') {
      return _.result(localStorage.getItem('pageConfigData') || {}, 'profileData.userInfoStyleValue', '');
    }
  } catch (e) {
    return '';
  }
}

/**
 * 返回键url
 */
export function getBackPageUrl() {
  try {
    if (typeof window !== 'undefined') {
      return _.result(localStorage.getItem('pageConfigData') || {}, 'profileData.backPageUrl', '');
    }
  } catch (e) {
    return '';
  }
}

/**
 * 返回键url
 */
export function initLocationBackPage(url) {
  window.history.pushState(null, null, '#');
  window.addEventListener(
    'popstate',
    () => {
      if (url) {
        track({
          location: 'sharelp',
          action: 'exposure',
          object: 'sharelp_backpage',
          ch: getProfileId(),
        });
        window.location.replace(url);
      }
    },
    false,
  );
}
